import React from 'react';
import { Form } from 'react-bootstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { resetAuthorFilter, setAuthorFilter, setAuthorOptions } from '../../../actions/filters';

class AuthorFilter extends React.Component {
  state = {
    filter: this.props.authorFilter,
  };

  componentDidMount() {
    this.props.setAuthorOptions(this.props.list);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.list !== this.props.list){
      this.props.setAuthorOptions(this.props.list);
    }
  }

  componentWillUnmount() {
    this.props.resetAuthorFilter();
  }

  handleFilterChange = (event) => {
    let filter = parseInt(event.currentTarget.value);
    this.setState({filter});
    this.props.setAuthorFilter(filter);
  };

  render() {
    const options = this.props.authorOptions.map(a => <option value={a.pk}>{a.name} ({a.count})</option>)
    return <Form.Group controlId="filter.author">
      <Form.Label>{gettext('Автор')}</Form.Label>
      <Form.Control as='select' size='sm' value={this.state.filter} onChange={this.handleFilterChange}>
        <option value={0}>{gettext('Все')}</option>
        {options}
      </Form.Control>
    </Form.Group>
  }
}

let mapStateToProps = (state) => {
  return {
    authorFilter: state.filters.authorFilter,
    authorOptions: state.filters.authorOptions
  }
};

export default compose(
  connect(mapStateToProps, { setAuthorFilter, resetAuthorFilter, setAuthorOptions })
)(AuthorFilter);
